import { render } from "./ColorPickerComponent.vue?vue&type=template&id=45d6d6ca"
import script from "./ColorPickerComponent.vue?vue&type=script&lang=js"
export * from "./ColorPickerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__